/**
 * grint-connect.js
 *
 * Handles the TheGrint email connect form on the Shopify storefront.
 * Submits the customer's TheGrint email to the backend for verification,
 * then shows the appropriate result state.
 */

(function () {
  'use strict';

  const cfg = window.GrintConnect || {};

  // ── DOM refs ───────────────────────────────────────────────────────────────
  const stateForm          = document.getElementById('gc-state-form');
  const stateLoading       = document.getElementById('gc-state-loading');
  const stateSuccess       = document.getElementById('gc-state-success');
  const stateAlreadyLinked = document.getElementById('gc-state-already-linked');
  const stateNotPro        = document.getElementById('gc-state-not-pro');
  const stateError         = document.getElementById('gc-state-error');

  const form               = document.getElementById('gc-form');
  const emailInput         = document.getElementById('gc-email-input');
  const fieldError         = document.getElementById('gc-field-error');
  const submitBtn          = document.getElementById('gc-submit-btn');
  const errorMessage       = document.getElementById('gc-error-message');
  const linkedMessage      = document.getElementById('gc-linked-message');

  const retryBtn           = document.getElementById('gc-retry-btn');
  const retryLinkedBtn     = document.getElementById('gc-retry-linked-btn');
  const retryNotProBtn     = document.getElementById('gc-retry-notpro-btn');

  // ── Helpers ────────────────────────────────────────────────────────────────

  const allStates = [stateForm, stateLoading, stateSuccess, stateAlreadyLinked, stateNotPro, stateError];

  function showState(el) {
    allStates.forEach(function (s) {
      if (s) s.classList.toggle('grint-connect__state--hidden', s !== el);
    });
  }

  function showForm() {
    if (emailInput) emailInput.value = '';
    if (fieldError) fieldError.classList.add('grint-connect__state--hidden');
    showState(stateForm);
  }

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  // ── Form submission ────────────────────────────────────────────────────────

  if (form) {
    form.addEventListener('submit', async function (e) {
      e.preventDefault();

      const grintEmail = emailInput ? emailInput.value.trim() : '';

      if (!isValidEmail(grintEmail)) {
        if (fieldError) fieldError.classList.remove('grint-connect__state--hidden');
        if (emailInput) emailInput.focus();
        return;
      }

      if (fieldError) fieldError.classList.add('grint-connect__state--hidden');

      if (!cfg.customerId) {
        showState(stateError);
        if (errorMessage) errorMessage.textContent = 'Please sign in to your shop account first.';
        return;
      }

      if (!cfg.appUrl) {
        showState(stateError);
        if (errorMessage) errorMessage.textContent = 'Configuration error: backend URL missing. Please contact support.';
        return;
      }

      showState(stateLoading);
      if (submitBtn) submitBtn.disabled = true;

      try {
        const response = await fetch(
          cfg.appUrl.replace(/\/$/, '') + '/.netlify/functions/auth-grint-start',
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              shopifyCustomerId: cfg.customerId,
              grintEmail,
            }),
          }
        );

        const data = await response.json();

        if (!response.ok || !data.success) {
          switch (data.error) {
            case 'already_linked':
              if (linkedMessage && data.message) linkedMessage.textContent = data.message;
              showState(stateAlreadyLinked);
              break;
            default:
              if (errorMessage && data.message) errorMessage.textContent = data.message;
              showState(stateError);
          }
          return;
        }

        showState(data.isPro ? stateSuccess : stateNotPro);

      } catch (err) {
        console.error('[GrintConnect] Request failed:', err);
        if (errorMessage) errorMessage.textContent = 'Could not connect to the server. Please try again.';
        showState(stateError);
      } finally {
        if (submitBtn) submitBtn.disabled = false;
      }
    });
  }

  // ── Retry buttons ──────────────────────────────────────────────────────────

  if (retryBtn)       retryBtn.addEventListener('click', showForm);
  if (retryLinkedBtn) retryLinkedBtn.addEventListener('click', showForm);
  if (retryNotProBtn) retryNotProBtn.addEventListener('click', showForm);

})();
